export default __webpack_public_path__ + "static/media/dispatchme.99d081e2.png";